import { render, staticRenderFns } from "./IndustryProposalSorting.vue?vue&type=template&id=62be099c&scoped=true"
import script from "./IndustryProposalSorting.vue?vue&type=script&lang=js"
export * from "./IndustryProposalSorting.vue?vue&type=script&lang=js"
import style0 from "./IndustryProposalSorting.vue?vue&type=style&index=0&id=62be099c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62be099c",
  null
  
)

export default component.exports